import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';
import { useListRoles } from 'src/features/roles/api/useListRoles';
import { UpdateUserFormSchemaValues } from 'src/features/users/utils/formSchema';
import { userMessages } from 'src/features/users/utils/messages';
import MultiSelectFormField from 'src/registry/components/forms/MultiSelectFormField';

type UserFormProps = {
    form: UseFormReturn<UpdateUserFormSchemaValues>;
    onSubmit: (values: UpdateUserFormSchemaValues) => void;
};

function UpdateUserForm({ onSubmit, form }: UserFormProps) {
    const { formatMessage } = useIntl();

    const { data } = useListRoles({});

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<UpdateUserFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(userMessages.name)}
            />
            <InputFormField<UpdateUserFormSchemaValues>
                form={form}
                name="username"
                label={formatMessage(userMessages.username)}
            />
            <InputFormField<UpdateUserFormSchemaValues>
                form={form}
                name="email"
                label={formatMessage(userMessages.email)}
            />
            <MultiSelectFormField<UpdateUserFormSchemaValues>
                form={form}
                name="roles"
                label={formatMessage(userMessages.roles)}
                options={data?.results}
            />
        </Form>
    );
}

export default UpdateUserForm;
